import { render, staticRenderFns } from "./InformeFlow.vue?vue&type=template&id=62cc95da&scoped=true&"
import script from "./InformeFlow.vue?vue&type=script&lang=js&"
export * from "./InformeFlow.vue?vue&type=script&lang=js&"
import style0 from "./InformeFlow.vue?vue&type=style&index=0&id=62cc95da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc95da",
  null
  
)

export default component.exports